import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_get_serialnumber_by_serialNumberCodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { serialNumberCode: string }): 
  Promise<{ result: { Id?: number, PackagingId?: number, Lot?: { Id?: number, MaterialId?: number, VendorLotId?: number }, LicensePlate?: { Id?: number, ShippingContainerId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_serialnumber_by_serialNumberCode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { serialNumberCode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, PackagingId?: number, Lot?: { Id?: number, MaterialId?: number, VendorLotId?: number }, LicensePlate?: { Id?: number, ShippingContainerId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_serialnumber_by_serialNumberCode/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { serialNumberCode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, PackagingId?: number, Lot?: { Id?: number, MaterialId?: number, VendorLotId?: number }, LicensePlate?: { Id?: number, ShippingContainerId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_serialnumber_by_serialNumberCode/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      serialNumberCode: string    }) {
        if(isNil(inParams.serialNumberCode)) {
          return true; 
        }
      return false;
    }
}
